import type { BlogPost } from '../types.js';

// Default blog list is strictly empty - only blogs present in MySQL or published via API/Admin are displayed
export const BLOG_POSTS: BlogPost[] = [];
